import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import merge from 'lodash/merge';
import qs from 'qs';
import List from '../List';
import { setCurentFacetsQuery } from '../../../actions/shared/facets';
import productsUtil, {
  parseProductQueryString,
  buildQueryString,
  convertFacetsToFiltersArray
} from '../../../utils/products.js';
import queryUtil from '../../../modules/ajio-util/query.js';
// import {getEncodedString} from "../../../modules/ajio-util/stringDecoder";
import { stringifyFacets } from '../../../utils/products.js';
import { setRequest } from '../../../actions/shared/request';
import commify from '../../../modules/ajio-util/commify.js';
import { showModal, hideModal } from '../../../actions/modal.js';
import Form from '../Form.js';
import BreadCrumb from '../BreadCrumb';
import hexCode from '../../../modules/ajio-util/hexCode.js';
import { toggleFacet, toggleFacetGroup } from '../../../actions/shared/productsData.js';
import { generateEvent } from '../../../utils/dataGrinch';

import MinMaxFilter from './MinMaxFilter';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import properties from '../../../modules/ajio-util/properties';
import {
  getEnableRating,
  getEnableRatingLabelPLP,
  getPriorityDeliveryPhase2Flag,
  getRushDeliveryFlag
} from '../../../refresh/selectors/featureFlagsSelector';
import { getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import { getEnableFilterImprovement, getFilterImprovementConfig, getEnableFilterImprovementPhase2 } from '../../../refresh/selectors/featureFlagsSelector';

/**
 *  'filterParameters' holds 'types of Facet'
 */

class FacetFilterDesktopLeftPane extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brandSearchKey: '',
      colorSearchKey: ''
    };
    this.facetItemsConfig = {
      itemsVisible: 5
    };
  }

  /**
   * Method to find whether Category filter is there or not
   * If Category filter is there then show More filter option
   */
  showAdvancedFilter() {
    const { groupEntities = {} } = this.props;
    const { All: facetsList = {} } = groupEntities;
    const { items = [] } = facetsList;
    if (items.includes('l1l3nestedcategory')) {
      return true;
    }
  }

  /**
   * Get query object for "currentFacet" inside facet object in store or set it into empty {}.
   */

  getFacetsQuery() {
    const { facetsQuery } = this.props;
    return merge({}, facetsQuery);
  }

  /**
   *  FacetQuery with key (pricerange) is appended on click of checckbox under price facet
   *  whereas the key (price) is appended due to explicit input of price inside input area.
   *
   *  That's why this method has only check for (price) so that the form used for price input area
   *  can be prefilled with default values.
   */

  getPriceFormDefaultValues = () => {
    const { facetsQuery = {} } = this.props;
    const priceFacet = facetsQuery.price ? facetsQuery.price[0] : null;
    if (priceFacet) {
      const priceRangeSplits = priceFacet.split(',');
      return {
        minPrice: priceRangeSplits[0] || '',
        maxPrice: priceRangeSplits[1] || ''
      };
    }
    return {
      minPrice: '',
      maxPrice: ''
    };
  };

  /**
   *  method the name L3 name from the entity
   *  name = Boys (L1 category) - Boxers, Briefs & Trunks (L3 category);
   */

  getL3CategoryFromName(name = '', lowerCase = false) {
    let l3Category;
    l3Category = name.substring(name.indexOf('-') + 1).trim();
    l3Category = lowerCase ? l3Category.toLowerCase() : l3Category;
    return l3Category;
  }

  /**
   *  method to get L1 (gender) name from the entity
   *  name = Boys (L1 category) - Boxers, Briefs & Trunks (L3 category);
   */
  getL1CategoryFromName(name = '', lowerCase = false) {
    let l1Category;
    const dashIndex = name.indexOf('-');
    l1Category = dashIndex > -1 ? name.substring(0, dashIndex).trim() : name.trim();
    l1Category = lowerCase ? l1Category.toLowerCase() : l1Category;
    return l1Category;
  }

  /**
   *  get the list of top 5 items to show upfront inside each facet (filter) category
   *  for each facets
   *
   *  "entities" may sometimes looks like (facettype - gender (l1) - productname (l3))
   *  "entities" has also detail about the of facets too.
   *  "entities" is group of data (facettype * ('code' inside values for each item of values inside facettype))
   *
   *   Method for getting top 5 items for 'l1l3nestedcategory' facets.
   *    1.First priority if something is selected.
   *    2.Second based on product count for remaining unselected item.
   */

  getTopValuesCategories(items = []) {
    const { entities = {}, plpGender, enableImprovedFacets } = this.props;

    let filteredItems = items;
    if (enableImprovedFacets && plpGender && plpGender.toLowerCase() !== 'general') {
      filteredItems = items.filter(entityId => {
        const entity = entities[entityId];
        if (!entity || !entity.name) return false;
        const l1Category = this.getL1CategoryFromName(entity.name, true);
        return l1Category === plpGender.toLowerCase();
      });
    }

    const l3Categories = filteredItems.reduce(
      (acc, entityId = {}) => {
        const entity = entities[entityId];
        const { name = '', count, selected, code } = entity;
        const l3Category = this.getL3CategoryFromName(name, true);

        if (acc.entities[l3Category] && selected && !acc.entities[l3Category].selected) {
          /**
           * If the category comes as selected from server and it's not selected inside the
           * acc.entities object. So make it selected.
           */
          acc.entities[l3Category].codes.push(code);
          acc.entities[l3Category].selected = true;
        } else if (acc.entities[l3Category]) {
          /**
           *  If the l3Category is available in the object (acc.entities),
           *  then increase the item count by adding the existing count.
           *  pushing the crossponding (code) inside the array (codes) which will help furthur
           *  in sorting.
           */
          acc.entities[l3Category].count = acc.entities[l3Category].count + count;
          acc.entities[l3Category].codes.push(code);
        } else if (!acc.entities[l3Category]) {
          /**
           *  If the l3Category is not added then initialize the new entry inside the object (acc.entities)
           */
          acc.entities[l3Category] = {
            ...entity,
            codes: [code],
            name: this.getL3CategoryFromName(name)
          };
          acc.results.push(l3Category);
        }
        return acc;
      },
      { entities: {}, results: [] }
    );

    let selectedCategories = this.groupCategoryItemOnSelection(l3Categories, true);
    let unSelectedCategories = [];

    if (selectedCategories.length != this.facetItemsConfig.itemsVisible) {
      unSelectedCategories = this.groupCategoryItemOnSelection(l3Categories, false);
    }

    return [...selectedCategories, ...unSelectedCategories];
  }

  groupCategoryItemOnSelection(l3Categories, groupBySelected) {
    let groupedCategories;
    groupedCategories = l3Categories.results
      .filter(l3CategoryId => {
        return groupBySelected
          ? l3Categories.entities[l3CategoryId].selected
          : !l3Categories.entities[l3CategoryId].selected;
      })
      .map(l3CategoryId => {
        return l3Categories.entities[l3CategoryId];
      })
      .sort((entityA, entityB) => {
        if (entityA.count > entityB.count) {
          return -1;
        } else if (entityA.count < entityB.count) {
          return 1;
        }
        return 0;
      });
    return groupedCategories;
  }

  /*
    Calculated the top values :
  *   1.'l1l3nestedcategory' (Known as 'Category' in view) is calculated on client-side based on item count.
  *   2.'pricerange' will list all the items upfront.
  *   3. other facets the list of top 5 items are coming from server in key (topValues) inside each facets object.
  */

  getTopValues(entity = {}, facetCode) {
    const { colorSearchKey, brandSearchKey } = this.state;
    let { topValues = [] } = entity;
    if (facetCode === 'l1l3nestedcategory' && entity.childrens) {
      return this.getTopValuesCategories(entity.childrens).slice(
        0,
        this.facetItemsConfig.itemsVisible
      );
    } else if (facetCode === 'verticalcolorfamily' && entity.childrens) {
      if (colorSearchKey) {
        return entity.childrens
          .filter(arr => arr.toLowerCase().indexOf(colorSearchKey.toLowerCase()) > 0)
          .slice(0, this.facetItemsConfig.itemsVisible); // filtering the search key work
      } else return entity.childrens.slice(0, this.facetItemsConfig.itemsVisible);
    } else if (facetCode === 'brand' && entity.childrens) {
      if (brandSearchKey) {
        return entity.childrens
          .filter(arr => arr.toLowerCase().indexOf(brandSearchKey.toLowerCase()) > 0)
          .slice(0, this.facetItemsConfig.itemsVisible); // filtering the search key work
      } else return entity.childrens.slice(0, this.facetItemsConfig.itemsVisible);
    } else if (!entity.topValues && entity.childrens) {
      if (facetCode == 'pricerange') {
        return entity.childrens;
      }
      return entity.childrens.slice(0, this.facetItemsConfig.itemsVisible);
    }
    return topValues;
  }

  getNextRequest(curatedObject = {}) {
    const { request = {} } = this.props;
    return {
      ...request,
      curatedQuery: { ...request.curatedQuery, ...curatedObject }
    };
  }

  handleGtmEventPush = (label, noOfFilter, code = '', event) => {
    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreen;
    const { facetsQuery = {} } = this.props;
    const filtersArray = convertFacetsToFiltersArray(facetsQuery);

    if (event === 'selectAll') {
      gtmEventPush({
        event: 'plp_filter_apply',
        event_category: 'product list interactions',
        event_action: `filter applied - ${code}`,
        event_label: label,
        no_of_filters: noOfFilter,
        store_type: 'luxe',
        screen_name: screenName,
        screen_type: screenType
      });
      // Send Segment
      segmentEventPush({
        event: 'Plp Filter Applied',
        event_category: 'product list interactions',
        event_action: `filter applied - ${code}`,
        event_label: label,
        no_of_filters: noOfFilter,
        l1_filter : code,
        l2_filter : label,
        store_type: 'luxe',
        screen_name: screenName,
        screen_type: screenType,
        ...(filtersArray.length > 0 && { filters: filtersArray })
      });
    } else if (event === 'selectOne') {
      gtmEventPush({
        event: 'plp_filter_apply',
        event_category: 'product list interactions',
        event_action: `filter applied - ${code}`,
        event_label: label,
        no_of_filters: noOfFilter,
        store_type: 'luxe',
        screen_name: screenName,
        screen_type: screenType
      });

      // Send segment
      segmentEventPush({
        event: 'Plp Filter Applied',
        event_category: 'product list interactions',
        event_action: `filter applied - ${code}`,
        event_label: label,
        no_of_filters: noOfFilter,
        l1_filter : code,
        l2_filter : label,
        store_type: 'luxe',
        screen_name: screenName,
        screen_type: screenType,
        ...(filtersArray.length > 0 && { filters: filtersArray })
      });

    } else if (event === 'removeOne') {
      gtmEventPush({
        event_name: 'plp_filter_apply',
        event_category: 'product list interactions',
        event_action: 'filter remove individual',
        event_label: label,
        no_of_filters: noOfFilter,
        store_type: 'luxe',
        screen_name: screenName,
        screen_type: screenType
      });
    // Send segment
    segmentEventPush({
      event: 'Plp Filter Applied',
      event_category: 'product list interactions',
      event_action: 'filter remove individual',
      event_label: label,
      no_of_filters: noOfFilter,
      l1_filter : code,
      l2_filter : label,
      store_type: 'luxe',
      screen_name: screenName,
        screen_type: screenType,
        ...(filtersArray.length > 0 && { filters: filtersArray })
    });
    } else if (event === 'removeAll') {
      gtmEventPush({
        event: 'plp_filter_remove',
        event_category: 'product list interactions',
        event_action: 'filter remove all',
        event_label: label,
        store_type: 'luxe',
        screen_name: screenName,
        screen_type: screenType
      });

      // Send segment
      segmentEventPush({
        event: 'Plp Filter Applied',
        event_category: 'product list interactions',
        event_action: 'filter remove all',
        event_label: label,
        store_type: 'luxe',
        l1_filter : code,
        l2_filter : label,
        screen_name: screenName,
        screen_type: screenType,
        ...(filtersArray.length > 0 && { filters: filtersArray })
      });
    }
  };

  getSelectedFacets = (childrens, entities) => {
    const value = childrens.map(arr => entities[arr].name);
    return value || null;
  };

  /**
   * Method to render the list of (items) childrens for each facets
   * @param {*} facetCode
   * @param {*} param1
   *
   */
  facetItemListItemRenderer(facetCode, topValues, { index }) {
    const { entities = {}, request = {}, newDesignLuxe } = this.props;
    const entity = entities[facetCode] || {};
    let topValueEntityId = topValues[index];
    let topValueEntity =
      typeof topValueEntityId === 'string' ? entities[topValueEntityId] : topValueEntityId;
    const { name, code, selected = false, count = 0 } = topValueEntity;
    let finalRatingName = '';
    const ratingItemContainer = {
      display: 'flex',
      height: '15px',
      alignItems: 'center',
      gap: '4px',
      fontSize: '14px',
      color: '#202020',
      marginRight: '5px',
      marginBottom: '6px'
    };

    const starIconOnFilterStyle = {
      width: '12px'
    };
    if (facetCode === 'rating') {
      const splitedArray = name.split('star');
      const imageBaseRef = `${properties.getProperty('imageBaseUrl')}/static/img/`;
      finalRatingName = (
        <span style={ratingItemContainer}>
          <p>{splitedArray[0]}</p>
          <img
            style={starIconOnFilterStyle}
            src={`${imageBaseRef}filled_star_rating.svg`}
            alt="Star"
          />
          <p>{splitedArray[1]}</p>
        </span>
      );
    }

    const handleFacetSelection = (e) => {
      e.preventDefault(); // Prevent default behavior
      let facetsQuery = this.getFacetsQuery();
      const oldFacetsQueryLength = facetsQuery[facetCode]?.length || 0;
      const codes = topValueEntity.codes || [code];
      let path = request.browserPath || request.pathname;

      if (facetsQuery[facetCode]) {
        codes.forEach(code => {
          if (facetsQuery[facetCode].includes(code)) {
            facetsQuery[facetCode].splice(facetsQuery[facetCode].indexOf(code), 1);
          } else {
            if (path.includes('/s/')) {
              !selected && facetsQuery[facetCode].push(code);
            } else {
              facetsQuery[facetCode].push(code);
            }
          }
        });
      } else {
        facetsQuery[facetCode] = codes;
      }

      if (facetsQuery[facetCode]?.length < 1) {
        delete facetsQuery[facetCode];
      }

      if (newDesignLuxe) {
        const gtFacetCode = facetsQuery[facetCode]?.toString() || '';
        const noOfFilter = gtFacetCode ? gtFacetCode.split(',').length : 0;
        this.handleGtmEventPush(
          gtFacetCode,
          noOfFilter,
          facetCode,
          oldFacetsQueryLength < noOfFilter ? 'selectOne' : 'removeOne'
        );
      } else {
        generateEvent({ Event: 'Filter', value: { 'ListOfFilters:': qs.stringify(facetsQuery) } });
            
        const gtFacetCode = facetsQuery[facetCode] ? facetsQuery[facetCode].toString() : '';
        const label = gtFacetCode.toString();
        const noOfFilter = gtFacetCode ? gtFacetCode?.split(',').length : 0;
        const filtersArray = convertFacetsToFiltersArray(facetsQuery);

        segmentEventPush({
          event: 'Plp Filter Applied',
          event_category: 'product list interactions',  
          event_action: 'selectOne',           
          no_of_filters: noOfFilter,
          l1_filter : facetCode,
          l2_filter : label,
          store_type: 'Ajio',
          screen_name: 'plp screen',
          screen_type: 'plp screen',
          ...(filtersArray.length > 0 && { filters: filtersArray })
        });
      }

      this.props.setCurentFacetsQuery(facetsQuery);
      this.props.pushToHistory({ facets: stringifyFacets(facetsQuery), currentPage: 0 });
    };

    // brickcfscategory 796
    return (
      <div
        className="facet-linkfref "
        key={`facet-item-${code}`}
        onClick={handleFacetSelection}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleFacetSelection(e);
          }
          if (facetsQuery[facetCode] && facetsQuery[facetCode].length < 1) {
            /**
             * Deleting the key if that facetQuery has no condition.
             */
            delete facetsQuery[facetCode];
          }
          if (newDesignLuxe) {
            const gtFacetCode = facetsQuery[facetCode] ? facetsQuery[facetCode].toString() : '';
            const label = gtFacetCode.toString();
            const noOfFilter = gtFacetCode ? gtFacetCode?.split(',').length : 0;
            this.handleGtmEventPush(
              label,
              noOfFilter,
              facetCode,
              oldFacetsQueryLength < noOfFilter ? 'selectOne' : 'removeOne'
            );
          } else {
            generateEvent({
              Event: 'Filter',
              value: {
                'ListOfFilters:': qs.stringify(facetsQuery)
              }
            });

            const gtFacetCode = facetsQuery[facetCode] ? facetsQuery[facetCode].toString() : '';
            const label = gtFacetCode.toString();
            const noOfFilter = gtFacetCode ? gtFacetCode?.split(',').length : 0;
            const filtersArray = convertFacetsToFiltersArray(facetsQuery);

            segmentEventPush({
              event: 'Plp Filter Applied',
              event_category: 'product list interactions',
              event_action: 'selectOne',           
              no_of_filters: noOfFilter,
              l1_filter : facetCode,
              l2_filter : label,
              store_type: 'Ajio',
              screen_name: 'plp screen',
              screen_type: 'plp screen',
              ...(filtersArray.length > 0 && { filters: filtersArray })
            });

          }

          this.props.setCurentFacetsQuery(facetsQuery);
          this.props.pushToHistory({
            facets: stringifyFacets(facetsQuery),
            currentPage: 0
          });
          return e.preventDefault();
        }}
        role={facetCode === 'rating' ? 'radio' : 'checkbox'}
        tabIndex={0}
        checked={selected}
        aria-checked={selected}
        aria-label={`${facetCode === 'rating' ? `${name.split('star')[0]} and Above Ratings` : name} with ${commify(count)} ${commify(count) == 1 ? 'item' : 'items'}`}
      >
        {facetCode === 'rating' ? (
          <div className="facet-linkhead">
            <input type="radio" name={facetCode} value={code} id={code} checked={selected} aria-checked={selected} aria-hidden='true'  tabIndex={-1} />
            <label
              className={`facet-linkname-rating facet-linkname-${facetCode} facet-linkname-${code}`}
              htmlFor={code}
              aria-hidden='true'
            >
              {finalRatingName}
              {` (${commify(count)})`}
            </label>
          </div>
        ) : (
          <div className="facet-linkhead">
            <input type="checkbox" name={facetCode} value={code} id={code} checked={selected} aria-hidden='true' tabIndex={-1} />
            <label
              className={`facet-linkname facet-linkname-${facetCode} facet-linkname-${code}`}
              htmlFor={code}
              aria-hidden='true'
              style={facetCode === 'verticalcolorfamily' ? { paddingLeft: '1px' } : {}}
            >
              {facetCode == 'verticalcolorfamily' ? (
                <i className="facet-checkbox-color-outer">
                  <i
                    className="facet-checkbox-color-inner"
                    style={{
                      backgroundColor: !newDesignLuxe && (hexCode(name.toLowerCase()) || name)
                    }}
                  />
                </i>
              ) : null}
              {facetCode == 'verticalcolorfamily' ? (<span
                style={{backgroundColor: newDesignLuxe && (hexCode(name.toLowerCase()) || name)}}
                className= {newDesignLuxe ? "luxe-text-left-color-box" : ""}
              />) :  null}
              {`${name} (${commify(count)})`}
            </label>
          </div>
        )}
      </div>
    );
  }

  hasURLContainsPrice() {
    let { search = '', pathname = '' } = window.location;
    search = decodeURIComponent(search);
    return search.search('price:') > -1;
  }

  /**
   * Select / Clear Facet items
   * (existingQueryParam) key inside "facetObj" gives the list of
   * applied facets for the query as a filters.
   * To Clear the facet just delete existingQueryParam[code];
   * To Select the facet append the existing query param with the new facet code to be selected
   */
  selectOrClearItems(facetObj = {}, selectAll = true) {
    const { entities, location = {}, facetsQuery = {}, request = {} } = this.props;
    let queryParam = '';
    const { code = '', childrens = [] } = facetObj;
    let existingQueryParam = this.parseQueryFromUrlForFacets() || {};

    if (
      selectAll &&
      existingQueryParam[code] &&
      childrens.length === existingQueryParam[code].length
    ) {
      return;
    }

    // || (!selectAll && !existingQueryParam[code])
    if (!selectAll && existingQueryParam[code]) {
      delete existingQueryParam[code];
    }
    let path = request.browserPath || request.pathname;

    if (!selectAll && path.includes('/s/')) {
      existingQueryParam = { ...existingQueryParam, ...facetsQuery };
      delete existingQueryParam[code];
    }

    Object.keys(existingQueryParam).map((itemCode, index) => {
      existingQueryParam[itemCode].map(itemValue => {
        queryParam = `${queryParam}:${itemCode}:${itemValue}`;
      });
    });

    if (selectAll) {
      let entity;

      if (path.includes('/s/') && Object.keys(facetsQuery).length) {
        Object.keys(facetsQuery).map((facetName, idx) => {
          facetsQuery[facetName].length &&
            facetsQuery[facetName].map(item => {
              if (!queryParam.includes(`${facetName}:${item}`)) {
                queryParam = `${queryParam}:${facetName}:${item}`;
              }
            });
        });
      }

      childrens.map((data, index) => {
        entity = entities[data] || {};
        if (
          !existingQueryParam[code] ||
          (existingQueryParam[code] && !existingQueryParam[code].includes(entity.code))
        ) {
          queryParam = `${queryParam}:${code}:${entity.code}`;
        }
      });
    }
    this.props.setCurentFacetsQuery(queryParam);
    this.props.pushToHistory({
      facets: stringifyFacets(queryParam),
      currentPage: 0
    });
  }

  /**
   * Method invoked to show "Select All" and  "Clear All" button
   * beside the category name
   */
  getSelectAllClearAll(facet,name) {
    let selectAllClearAll;
    selectAllClearAll = (
      <div className="facet-slctclr">
        {facet && facet.code !== 'rating' &&
        <div
          className="facet-slct"
          onClick={e => {
            const { newDesignLuxe, entities } = this.props;
            this.selectOrClearItems(facet, true);
            let { code = '', childrens = [] } = facet;
            let obj = {};
            obj[code] = childrens;
            const facetsQuery = this.getFacetsQuery();
            if (newDesignLuxe) {
              const facet = this.getSelectedFacets(childrens, entities);
              const label = facet.toString();
              const noOfFilter = facet.length;
              this.handleGtmEventPush(label, noOfFilter, code, 'selectAll');
            } else {
              generateEvent({
                Event: 'Filter',
                value: {
                  'ListOfFilters:': qs.stringify({ ...obj, ...facetsQuery })
                }
              });
              
              
              segmentEventPush({
                event: 'Plp Filter Applied',
                event_category: 'product list interactions',  
                event_action: 'selectAll',            
                no_of_filters: qs.stringify(facetsQuery),
                l1_filter : code,               
                store_type: 'Ajio',
                screen_name: 'plp screen',
                  screen_type: 'plp screen',
                  ...(convertFacetsToFiltersArray(facetsQuery).length > 0 && {
                    filters: convertFacetsToFiltersArray(facetsQuery)
                  })
              });

            }

            document.getElementById('facet-status-msg').textContent = `All items in ${name} selected`;
            e.stopPropagation();
          }}
          aria-label={`Select All ${name} options`}
          role="button"
          tabIndex={0}
        >
          Select All
        </div>}
        {facet && facet.code !== 'rating' && <span aria-hidden="true">|</span>}
        <div
          className="facet-clr"
          onClick={e => {
            this.selectOrClearItems(facet, false);
            const { newDesignLuxe, entities } = this.props;
            let { code = '', childrens = [] } = facet;
            let obj = {};
            obj[code] = [];
            const facetsQuery = this.getFacetsQuery();
            if (newDesignLuxe) {
              const facet = this.getSelectedFacets(childrens, entities);
              const label = facet.toString();
              const noOfFilter = facet.length;
              this.handleGtmEventPush(label, noOfFilter, code, 'removeAll');
            } else {
              generateEvent({
                Event: 'Filter',
                value: {
                  'ListOfFilters:': qs.stringify({ ...obj, ...facetsQuery })
                }
              });

              
              segmentEventPush({
                event: 'Plp Filter Applied',
                event_category: 'product list interactions',
                event_action: 'removeAll',              
                no_of_filters: qs.stringify(facetsQuery),
                l1_filter : code,               
                store_type: 'Ajio',
                screen_name: 'plp screen',
                screen_type: 'plp screen',
                ...(convertFacetsToFiltersArray(facetsQuery).length > 0 && {
                  filters: convertFacetsToFiltersArray(facetsQuery)
                })
              });
              
            }
            document.getElementById('facet-status-msg').textContent = `All items in ${name} cleared`;
            e.stopPropagation();
          }}
          aria-label={`Clear All ${name} options`}
          role="button"
          tabIndex={0}
        >
          Clear All
        </div>
      </div>
    );
    return selectAllClearAll;
  }

  // show text for size and fit description
  selectSizeFitText = (entities, query) => {
    const {
      genderfilter: genderfilterVal = {},
      l1l3nestedcategory: l1l3nestedcategoryVal = {}
    } = entities;
    const { childrens: genderfilterChild = [] } = genderfilterVal;
    const { genderfilter = [], l1l3nestedcategory = [] } = query;
    const { plpGender, enableImprovedFacetsPhase2 } = this.props;
    let categoryValues = this.getTopValues(l1l3nestedcategoryVal, l1l3nestedcategoryVal.code);
    let textValue = '';
    const shouldHideGenderText = enableImprovedFacetsPhase2 && plpGender && plpGender.toLowerCase() !== 'general';

    if (
      !shouldHideGenderText &&
      genderfilterChild.length > 1 &&
      categoryValues.length > 1 &&
      genderfilter.length === 0 &&
      l1l3nestedcategory.length === 0
    ) {
      textValue = 'select gender and category';
    } else if (categoryValues.length > 1 && l1l3nestedcategory.length === 0) {
      textValue = 'select a category';
    } else if (!shouldHideGenderText && genderfilterChild.length > 1 && genderfilter.length === 0) {
      textValue = 'select a gender';
    }

    return textValue;
  };

  /**
   * Method invoked inside the render method of this component to list the facets
   * entities has information about facets also.
   * facets like "l1l3nestedcategory (Category)", "occasion", "pricerange" etc.
   * facets.childrens is array [] and items inside will follow pattern :
   *  {(facettype) - gender (L1 Category) - Product Name (L3 Category)}
   *  example: "l1l3nestedcategory-Boys - Boxers, Briefs & Trunks",
   *      "l1l3nestedcategory-Boys - FlipFlops & Slippers"
   */
  handleClick = selectSizeDesc => {
    const code = selectSizeDesc === 'select a gender' ? 'genderfilter' : 'l1l3nestedcategory';
    const modalName =
      code == 'l1l3nestedcategory' ? 'facet-filter-modal-category' : 'facet-filter-modal';
    this.props.showModal(modalName, {
      state: { facetId: code }
    });
  };

  gaPlpFilterMenuOpen = () => {
    const { newDesignLuxe } = this.props;
    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreen;

    if (newDesignLuxe) {
      gtmEventPush({
        event: 'plp_filter_menu_open',
        event_category: 'product list interactions',
        event_action: 'filter menu open',
        store_type: 'luxe',
        screen_name: screenName,
        screen_type: screenType
      });
    }
  };

  facetListItemRenderer = (filterParameters, { index }) => {
    const {
      entities,
      selectedFilter,
      facetsQuery,
      openFacets = [],
      newDesignLuxe,
      enableRating,
      enableRatingLabelPLP,
      storeName,
      enableImprovedFacets,
      plpGender
    } = this.props;
    let isFacetSelected = false;
    const id = filterParameters[index];
    const entity = entities[id] || {};
    const { name, code, childrens = [] } = entity;
    const topValues = this.getTopValues(entity, code);

    /* 
      Commenting the below code for https://devops.jio.com/Retail/E-Com_DCFL/_workitems/edit/236894/
      Style Type should not be shown at the top
      Style Type will be shown on LHS of the page
    */

    // if (code === "brickstyletype")
    //   return null;

    if (facetsQuery[code] && facetsQuery[code].length > 0) {
      isFacetSelected = true;
    }
    if (code == 'pricerange' && facetsQuery.price && facetsQuery.price.length > 0) {
      isFacetSelected = true;
    }
    const selectSizeDesc = this.selectSizeFitText(entities, facetsQuery);
    if (
      code === 'rating' &&
      (!enableRating ||
        !enableRatingLabelPLP ||
        storeName === 'luxe')
    ) {
      return null;
    }

    if (
      enableImprovedFacets &&
      code?.toLowerCase() === 'genderfilter' &&
      plpGender &&
      plpGender?.toLowerCase() !== 'general'
    ) {
      return null;
    }

    return (
      <div>
        <div className={`cat-facets ${name.length > 10 ? 'facet-class-hover' : ''}`}>
          <div className={`facet-head`} >
            <div className={`facet-head-before ${!openFacets.includes(code) ? '' : 'facet-xpndicon'}`} 
              onClick={() => this.props.toggleFacet(code)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  this.props.toggleFacet(code);
                }
              }}
              tabIndex={0}
              role="button"
              aria-expanded={Array.isArray(openFacets) && openFacets.includes(code)}
              aria-label={name.toLowerCase()}>
            <span>
              <span className={`${isFacetSelected ? 'ic-selected-facet' : 'ic-unselected-facet'}`} aria-hidden="true" />
              <span className="facet-left-pane-label">
                {/* {name.toLowerCase()} */}
                {code === 'genderfilter' ? this.props.filterImprovementConfig?.gender?.title || "Shop For" : name.toLowerCase()}
              </span>
            </span>
            </div>
            {this.getSelectAllClearAll(entity,name)}
            <div
              id="facet-status-msg"
              className="sr-only"
              aria-live="polite"
              aria-atomic="true"
            ></div>
          </div>

          {openFacets.includes(code) && (
            <div className="facet-body">
              {newDesignLuxe && (code == 'verticalcolorfamily' || code == 'brand') ? (
                <div className="facet-input">
                  <input
                    type="text"
                    placeholder={
                      code === 'verticalcolorfamily' ? 'Search for colors' : 'Search for brands'
                    }
                    onChange={({ target: { value } }) =>
                      code === 'verticalcolorfamily'
                        ? this.setState({ colorSearchKey: value })
                        : this.setState({ brandSearchKey: value })
                    }
                  />
                </div>
              ) : null}

              {code === 'verticalsizegroupformat' && selectSizeDesc && (
                <div
                  className="facet-size-fit-category-description"
                  aria-label={`For better results, ${selectSizeDesc}`}
                >
                  For better results,
                  <span
                    className="select-category-text"
                    onClick={() => {
                      this.handleClick(selectSizeDesc);
                      this.gaPlpFilterMenuOpen();
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    {' '}
                    {selectSizeDesc}
                  </span>
                </div>
              )}
              {(code == 'pricerange' && !this.hasURLContainsPrice()) ||
              ![
                'pricerange',
                'dohL30',
                'netDohL30',
                'inTakeMarginPerc',
                'ageing',
                'inStockPerc',
                'rosL30',
                'netRosL30'
              ].includes(code) ? (
                <List
                keepDefaultRole={true}
                  numOfItems={topValues.length}
                  listItemRenderer={this.facetItemListItemRenderer.bind(this, code, topValues)}
                />
              ) : null}
              {[
                'dohL30',
                'netDohL30',
                'inTakeMarginPerc',
                'ageing',
                'inStockPerc',
                'rosL30',
                'netRosL30'
              ].includes(code) ? (
                <MinMaxFilter
                  code={code}
                  facetsQuery={this.props.facetsQuery}
                  setCurentFacetsQuery={this.props.setCurentFacetsQuery}
                  pushToHistory={this.props.pushToHistory}
                />
              ) : null}
              {code == 'pricerange' ? (
                <Form
                  getFormState={() => {
                    const { priceFormState = {} } = this.state;
                    const nextPriceFormState = { ...priceFormState };
                    nextPriceFormState.formValues =
                      nextPriceFormState.formValues || this.getPriceFormDefaultValues();
                    return nextPriceFormState;
                  }}
                  setFormState={(nextFormState, done) => {
                    const prevFormState = this.state.priceFormState || {};
                    this.setState({ priceFormState: { prevFormState, ...nextFormState } }, done);
                  }}
                  onSubmit={formValues => {
                    const { priceFormState = {} } = this.state;
                    const facetsQuery = this.getFacetsQuery();

                    if (facetsQuery && facetsQuery.pricerange) {
                      delete facetsQuery.pricerange;
                    }

                    generateEvent({
                      Event: 'Filter',
                      value: {
                        'ListOfFilters:': qs.stringify(facetsQuery)
                      }
                    });
                    /**
                     * Setting query (price)
                     */
                    facetsQuery.price = [`${formValues.minPrice},${formValues.maxPrice}`];
                    this.props.setCurentFacetsQuery(facetsQuery);
                    this.props.pushToHistory({
                      facets: stringifyFacets(facetsQuery),
                      currentPage: 0
                    });
                    this.setState({
                      priceFormState: { ...priceFormState, formValues: null }
                    });
                  }}
                  validateForm={formValues => {
                    let { minPrice, maxPrice } = formValues;
                    minPrice = parseInt(minPrice);
                    maxPrice = parseInt(maxPrice);
                    if (minPrice == 0 && maxPrice > 0) {
                      return {};
                    } else if (minPrice > maxPrice) {
                      return {
                        error: 'Min Price cannot be greater than Max Price'
                      };
                    } else if (minPrice == maxPrice) {
                      return { error: 'Min and Max Price cannot be same' };
                    } else if (!minPrice || !maxPrice) {
                      return { error: 'Please enter your price range' };
                    } else {
                      return {};
                    }
                  }}
                >
                  {({
                    getFormDefaultProps,
                    getFormValue,
                    isTouched,
                    addFormValue,
                    formValues,
                    formError,
                    resetAll
                  }) => {
                    return (
                      <div className="price-container">
                        <div className="input-price-filter" role='group' aria-labelledby='enter-range-title'>
                    

                          <div className="price-range-title">
                            <span id="enter-range-title" role="heading" aria-level={2}>Enter Price Range</span>
                            <span
                              className="clear-all"
                              onClick={e => {
                                resetAll();
                                const facetsQuery = this.getFacetsQuery();

                                if (facetsQuery && facetsQuery.price) {
                                  delete facetsQuery.price;
                                  this.props.setCurentFacetsQuery(facetsQuery);
                                  this.props.pushToHistory({
                                    facets: stringifyFacets(facetsQuery),
                                    currentPage: 0
                                  });
                                }
                                this.setState({ clearMessage: "Price range inputs cleared" });
                                e.stopPropagation();
                              }}
                              role="button"
                              tabIndex={0}
                              aria-label='Clear Price Range'
                            >
                              Clear
                            </span>
                          </div>
                          <div className="facet-min-price-filter">
                            <input
                              {...getFormDefaultProps({
                                type: 'text',
                                pattern: 'd*',
                                name: 'minPrice'
                              })}
                              onChange={event => {
                                const { name, value } = event.target;
                                const isNum = /^\d+$/.test(value);
                                if (value != null && isNum) {
                                  addFormValue(name, value);
                                } else if (value == '') {
                                  addFormValue(name, value);
                                }
                              }}
                              autoComplete="off"
                              id="minPrice"
                              placeholder="Min"
                              maxLength="6"
                              aria-label="Enter Minimum Value"
                              aria-describedby='price-filter-error'
                            />
                            <span className="ic-price-separator" />
                            <input
                              {...getFormDefaultProps({
                                type: 'text',
                                pattern: 'd*',
                                name: 'maxPrice'
                              })}
                              onChange={event => {
                                const { name, value } = event.target;
                                const isNum = /^\d+$/.test(value);
                                if (value != null && isNum) {
                                  addFormValue(name, value);
                                } else if (value === '') {
                                  addFormValue(name, value);
                                }
                              }}
                              autoComplete="off"
                              placeholder="Max"
                              id="maxPrice"
                              maxLength="6"
                              aria-label="Enter maximum value"
                            />
                            {newDesignLuxe ? (
                              ''
                            ) : (
                              <button
                                type="submit"
                                className="rilrtl-button ic-toparw"
                                aria-label="Apply price filter"
                              />
                            )}
                            <div id="price-filter-error" className="price-error" aria-live='polite' role='alert'>{formError.error}</div>
                            {newDesignLuxe ? (
                              <button type="submit" className="rilrtl-button submit-text">
                                Submit
                              </button>
                            ) : (
                              ''
                            )}
                              <div
                                aria-live="polite"
                                role="status"
                                style={{
                                  position: 'absolute',
                                  height: '1px',
                                  width: '1px',
                                  overflow: 'hidden',
                                  clip: 'rect(1px, 1px, 1px, 1px)',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {this.state.clearMessage}
                              </div>

                          </div>
                        {/* </fieldset> */}

                        </div>
                      </div>
                    );
                  }}
                </Form>
              ) : null}
              {childrens.length > this.facetItemsConfig.itemsVisible && code !== 'pricerange' ? (
                <div
                  id={`verticalsizegroupformat-${code}`}
                  className="facet-more"
                  onClick={() => {
                    const modalName =
                      code == 'l1l3nestedcategory'
                        ? 'facet-filter-modal-category'
                        : 'facet-filter-modal';
                    this.props.showModal(modalName, {
                      state: { facetId: code,
                        onClose:function(){
                          requestAnimationFrame(() => {
                            const moreEle = document.getElementById(`verticalsizegroupformat-${code}`);
                            if (moreEle) {
                              moreEle.focus();
                            }
                          });
                        }
                       }
                    });
                    this.gaPlpFilterMenuOpen();
                  }}

                  onKeyDown={(event) => {
                    if (event.key == ' ') {
                      const modalName =
                        code == 'l1l3nestedcategory'
                          ? 'facet-filter-modal-category'
                          : 'facet-filter-modal';
                      this.props.showModal(modalName, {
                        state: { facetId: code ,
                          onClose:function(){
                            requestAnimationFrame(() => {
                              const moreEle = document.getElementById(
                                `verticalsizegroupformat-${code}`
                              );
                              if (moreEle) {
                                moreEle.focus();
                              }
                            });
                          }
                        }
                      });
                      this.gaPlpFilterMenuOpen();
                    }
                  }}
                  aria-label={
                    newDesignLuxe
                      ? `+${childrens.length - this.facetItemsConfig.itemsVisible} More`
                      : 'MORE'
                  }
                  role="button"
                  tabIndex={0}
                >
                  <strong>
                    {newDesignLuxe
                      ? `+${childrens.length - this.facetItemsConfig.itemsVisible} More`
                      : 'MORE'}
                  </strong>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  };

  getDeviceType() {
    let deviceType = 'DESKTOP';
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      deviceType = 'MSITE';
    }
    return deviceType;
  }

  getListItems = items => {
    let device = this.getDeviceType();
    const { enableRushDelivery, enablePriorityDeliveryPhase2 } = this.props;
    if (device === 'DESKTOP' || !(enableRushDelivery || enablePriorityDeliveryPhase2)) {
      items = items.filter(item => item !== 'sla');
    }
    return items || [];
  };

  render() {
    const {
      groupEntities = {},
      closedFacetGroups = [],
      isAdvanceFacetsEnabled = false,
      metaData: { name = '', sis = false } = {},
      rilfnlBreadCrumb = [],
      newDesignLuxe
    } = this.props;
    const { Common: common = {}, Advance: advance = {}, All: all = {} } = groupEntities;
    return (
      <div role="region" aria-label="Product Filter options " className="facets" id="facets">
       
        <div
          className={`${
            newDesignLuxe
              ? 'facet-typehead'
              : closedFacetGroups.includes('commonFilter')
              ? 'facet-arwdwn facet-typehead'
              : 'facet-arwup facet-typehead'
          } `}
          onClick={() => {
            this.props.toggleFacetGroup('commonFilter');
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.props.toggleFacetGroup('commonFilter');
            }
          }}
          tabIndex={0}
          role="button"
          aria-expanded={!closedFacetGroups.includes('commonFilter')}
          aria-describedby='filter-note'
        >
          <strong>{newDesignLuxe ? 'Filters' : 'Refine By'}</strong>
        </div>
        <div className='sr-only' aria-hidden="true">
          <div id="filter-note">Note: When an option is selected, it may move to the top of the list.</div>
        </div>
        {isAdvanceFacetsEnabled ? (
          <div className="facet-typebody">
            {common.items &&
              common.items.length > 0 &&
              !closedFacetGroups.includes('commonFilter') && (
                <List
                keepDefaultRole ={true}
                  numOfItems={this.getListItems(common.items).length}
                  listItemRenderer={this.facetListItemRenderer.bind(
                    this,
                    this.getListItems(common.items)
                  )}
                />
              )}
            {advance.items && advance.items.length > 0 ? (
              <div className="facet-advanced-filter-block">
                <div
                  className={`facet-typehead ${
                    closedFacetGroups.includes('advancedFilter') ? 'facet-arwdwn' : 'facet-arwup'
                  }`}
                  onClick={() => {
                    this.props.toggleFacetGroup('advancedFilter');
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      this.props.toggleFacetGroup('advancedFilter');
                    }
                  }}
                  aria-label="More Filters"
                  role="button"
                  tabIndex={0}
                  aria-expanded={!closedFacetGroups.includes('advancedFilter')}
                >
                  <strong>More Filters</strong>
                </div>
                {!closedFacetGroups.includes('advancedFilter') && (
                  <List
                    keepDefaultRole={true}
                    numOfItems={advance.items.length}
                    listItemRenderer={this.facetListItemRenderer.bind(this, advance.items)}
                  />
                )}
              </div>
            ) : (
              <div>
                {this.showAdvancedFilter() && (
                  <div>
                    <div
                      className={`facet-typehead ${
                        closedFacetGroups.includes('advancedFilter')
                          ? 'facet-arwdwn'
                          : 'facet-arwup'
                      }`}
                      onClick={() => {
                        this.props.toggleFacetGroup('advancedFilter');
                      }}
                        onKeyDown={(event) => {
                          if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            this.props.toggleFacetGroup('advancedFilter');
                          }
                        }}
                      aria-label="More Filters"
                      role="button"
                      tabIndex={0}
                    >
                      <strong>More Filters</strong>
                    </div>
                    {!closedFacetGroups.includes('advancedFilter') && (
                      <div>
                        <div
                          className="facet-advanced-filter-description"
                          aria-label="Please select upto 3 categories to view more filters"
                        >
                          Please select upto 3 categories to view more filters
                        </div>
                        <div
                          className="rilrtl-button rilrtl-button--select-category"
                          onClick={() => {
                            const code = 'l1l3nestedcategory';
                            const modalName =
                              code == 'l1l3nestedcategory'
                                ? 'facet-filter-modal-category'
                                : 'facet-filter-modal';
                            this.props.showModal(modalName, {
                              state: { facetId: code }
                            });
                          }}
                          aria-label="Select Category"
                          role="button"
                          tabIndex={0}
                        >
                          <strong>Select Category</strong>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="facet-typebody">
            {all.items && all.items.length > 0 && (
              <List
              keepDefaultRole ={true}
                numOfItems={this.getListItems(all.items).length}
                listItemRenderer={this.facetListItemRenderer.bind(
                  this,
                  this.getListItems(all.items)
                )}
              />
            )}
          </div>
        )}
        <div id="lastChild" />
      </div>
    );
  }

  parseQueryFromUrlForFacets() {
    const { location = {} } = this.props;
    const queryString = queryUtil.parseSearch(location.search) || {};
    const query = parseProductQueryString(queryString.query || '');
    const { facets } = query;
    return productsUtil.parseFacets(facets);
  }

componentDidMount() {
  const facetsQuery = this.parseQueryFromUrlForFacets();
  let { request = {}, plpGender, entities = {}, enableImprovedFacets = false } = this.props;
  let path = request.browserPath || request.pathname || '';
  if (!path.includes('/s/')) {
    // FILTER IMPROVEMENT: Auto-select gender if applicable
    // let shouldPushHistory = false;  
    // if (enableImprovedFacets && 
    //     plpGender && 
    //     plpGender.toLowerCase() !== 'general' && 
    //     !facetsQuery.genderfilter) { 
    //   const genderEntity = entities?.genderfilter;
    //   if (genderEntity && genderEntity.childrens) {
    //     const matchingGenderCode = genderEntity.childrens.find(childId => {
    //       const childEntity = entities[childId];
    //       return childEntity?.name?.toLowerCase() === plpGender.toLowerCase();
    //     });
        
    //     if (matchingGenderCode) {
    //       const genderCode = entities[matchingGenderCode]?.code;
    //       if (genderCode) {
    //         facetsQuery.genderfilter = [genderCode];
    //         shouldPushHistory = true;
    //       }
    //     }
    //   }
    // }
    // // Always set the current facets query
    // this.props.setCurentFacetsQuery(facetsQuery);   
    // // Only push to history if we modified it
    // if (shouldPushHistory) {
    //   this.props.pushToHistory({ 
    //     facets: stringifyFacets(facetsQuery), 
    //     currentPage: 0 
    //   });
    // }
    this.props.setCurentFacetsQuery(facetsQuery);
  }
}
}

function mapStateToProps(state) {
  const { facets = {}, grid = {}, request = {}, metaData = {}, flags } = state;
  const { currentFacets = {}, isAdvanceFacetsEnabled = false, plpGender = "" } = facets;
  const { closedFacetGroups = [], openFacets = [] } = grid;
  const {
    groupResults = [],
    groupEntities = {},
    entities = {},
    query: facetsQuery = {}
  } = currentFacets;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const enablePriorityDeliveryPhase2 = getPriorityDeliveryPhase2Flag(flags) || false;
  const enableRushDelivery = getRushDeliveryFlag(state) || false;

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    newDesignLuxe,
    groupResults,
    groupEntities,
    entities,
    facetsQuery,
    closedFacetGroups,
    openFacets,
    request,
    isAdvanceFacetsEnabled,
    metaData,
    enableRating: getEnableRating(flags, state),
    enableRatingLabelPLP: getEnableRatingLabelPLP(state) === 'ON',
    storeName,
    enablePriorityDeliveryPhase2,
    enableRushDelivery,
    enableImprovedFacets: getEnableFilterImprovement(state) || false,
    enableImprovedFacetsPhase2: getEnableFilterImprovementPhase2(state) || false,
    filterImprovementConfig: getFilterImprovementConfig(state) || {},
    plpGender
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setCurentFacetsQuery: query => {
      dispatch(setCurentFacetsQuery(query));
    },
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    toggleFacetGroup: id => {
      dispatch(toggleFacetGroup(id));
    },
    toggleFacet: id => {
      dispatch(toggleFacet(id));
    },
    setRequest: request => {
      dispatch(setRequest(request));
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FacetFilterDesktopLeftPane));
